import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class UcsTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (UcsTypeModel._instance == null) UcsTypeModel._instance = new UcsTypeModel(authManager);
        return UcsTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/ucs-types', 'geo-sections/ucs-types/codelist');

        this.entityName = 'geo-sections.UcsType';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Ucs Type';
        this.setLabel = 'Ucs Types';

        this.browser = {
            name: 'default-geo-sections-ucstype-browser',
            moduleName: 'default-geo-sections-ucstype-browser',
            moduleTitle: 'Ucs Types',
            moduleStateSlotName: 'default-geo-sections-ucstype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-ucstype-editor',
            moduleName: 'default-geo-sections-ucstype-editor',
            moduleTitle: 'Ucs Type',
            moduleStateSlotName: 'default-geo-sections-ucstype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'designation',
                type: 'string',
                persistent: true,
                label: 'Designation',
            },
            {
                name: 'strengthName',
                type: 'string',
                persistent: true,
                label: 'Strength Name',
            },
            {
                name: 'codeStandardDocumentId',
                type: 'CodeStandardDocument',
                persistent: true,
                label: 'Code Standard Document',
            },
            {
                name: 'characteristicsEn',
                type: 'string',
                persistent: true,
                label: 'Characteristics',
            },
            {
                name: 'ucs',
                type: 'string',
                persistent: true,
                label: 'Ucs',
            },
            {
                name: 'rockTypes',
                type: 'string',
                persistent: true,
                label: 'Rock Types',
            },
        ];

    }

}
